import { render, staticRenderFns } from "./RemediationBatchData.vue?vue&type=template&id=6f0d1efb"
import script from "./RemediationBatchData.vue?vue&type=script&lang=js"
export * from "./RemediationBatchData.vue?vue&type=script&lang=js"
import style0 from "./RemediationBatchData.vue?vue&type=style&index=0&id=6f0d1efb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports